import { render, staticRenderFns } from "./BsnPlan2List.vue?vue&type=template&id=5e7e5a1c&"
import script from "./BsnPlan2List.vue?vue&type=script&lang=js&"
export * from "./BsnPlan2List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports